import React from 'react';

const MenuContext = React.createContext<any>({});
const MenuParentContext = React.createContext<any>({});

export { MenuParentContext };
export default MenuContext;
